import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrash,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { deleteFacilityRegistration } from "actions/action";
import { getFacilityRegistrationInfo } from "actions/action";
import { Toaster, toast } from "react-hot-toast";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { QRCodeCanvas } from "qrcode.react";
import * as ReactDOM from "react-dom";
import dayjs from "dayjs";

const ViewFacilityRegistration = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
  const { fid, fname } = location.state;
  const userId = localStorage.getItem("user_id");
  const clubName = localStorage.getItem("club_name");
  const [alternateMembers, setAlternateMembers] = useState([]);
  const [formData, setFormData] = useState({
    id: "",
    data: null,
  });
  const [originalData, setOriginalData] = useState();

  // {
  //         "facility_registration_id": 19,
  //         "facility_id": 3,
  //         "user_id": 2,
  //         "purpose": "svssddfsd",
  //         "club_id": null,
  //         "description": "hey",
  //         "alternate_contact_details": null,
  //         "status": "pending",
  //         "start_time": "00:00:00",
  //         "end_time": "00:00:00"
  //     }
  const fetchFormData = async () => {
    try {
      const response = await getFacilityRegistrationInfo(fid, userId);
      console.log("r", response);
      if (response.status !== 404) {
        const data = response.data.registration;
        setOriginalData(data);
        //console.log(data);
        const excludeKeys = [
          "facility_id",
          "club_id",
          "user_id",
          "facility_registration_id",
          "alternate_contact_details",
        ];
        const filteredData = Object.fromEntries(
          Object.entries(data).filter(([key]) => !excludeKeys.includes(key))
        );

        if (data.alternate_contact_details) {
          // const am = JSON.parse(data.alternate_contact_details).members;

          const formattedText = data.alternate_contact_details.members.map(
            (item) => `${item.name}-${item.contact}-${item.email}`.trim()
          );
          setAlternateMembers(formattedText);
        }

        setFormData({
          ...formData,
          id: data.facility_registration_id,
          data: filteredData,
        });
      } else {
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong!", err);
    }
  };

  const encryptData = (registration_id) => {
    if (!registration_id) {
      toast.error("Error: registration_id is missing");
      return null;
    }
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(registration_id),
      SECRET_KEY
    ).toString();
    return encrypted;
  };

  const handleDeleteFacilityRegistration = async (id) => {
    try {
      const getApiResponse = await deleteFacilityRegistration(id);
      if (getApiResponse.status == 200) {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  const decryptData = (encryptedData) => {
    try {
      if (!encryptedData) {
        throw new Error("Error: Scanned data is empty");
      }

      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
        throw new Error("Decryption failed or returned empty string");
      }

      return decryptedString;
    } catch (error) {
      toast.error("Decryption error:", error.message);
      return null;
    }
  };

  const handleScan = async (id, scannedData, item) => {
    if (!scannedData) return;

    try {
      const decryptedId = decryptData(scannedData);

      if (Number(decryptedId) !== Number(item.facility_registration_id)) {
        Swal.fire("Error", "QR Code does not match any records!", "error");
        return;
      }

      if (item.status !== "issued") {
        Swal.fire("Warning", "This item is not in 'issued' state!", "warning");
        return;
      }

      const requestData = {
        registrationId: Number(decryptedId),
        status: "received",
      };

      const response = await fetch(
        `https://api.nvcti.in/facility/registration/updateFacilityRegistrationStatus/${encryptData}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        const errorText = await response.text();
        throw new Error(`Invalid JSON response: ${errorText}`);
      }

      if (response.ok) {
        Swal.fire("Success", "Status updated to 'received'!", "success").then(
          () => {
            window.location.reload();
          }
        );
      } else {
        Swal.fire("Error", data.message || "Failed to update status", "error");
      }
    } catch (error) {
      toast.error("QR Scan Error:", error);
      Swal.fire(
        "Error",
        "Something went wrong while processing the QR code.",
        "error"
      );
    }
  };

  const handleShowQR = (id, item) => {
    //console.log(id, item);
    const encryptedData = encryptData(id);

    Swal.fire({
      title: "SCAN QR",
      html: `
                <p style="margin-bottom: 15px; font-size: 14px;">Scan this QR code to retrieve information securely.</p>
                <div id="qrcode-container" style="display: flex; justify-content: center; margin-bottom: 15px;"></div>
                
                <div style="display: flex; justify-content: center; gap: 10px;">
                    <button id="cancel-button" class="swal2-cancel swal2-styled custom-cancel-btn">Cancel</button>
                </div>
            `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        const qrContainer = document.getElementById("qrcode-container");
        if (qrContainer) {
          ReactDOM.createRoot(qrContainer).render(
            <QRCodeCanvas
              value={encryptedData}
              size={150}
              onScan={(data) => {
                if (data) {
                  handleScan(id, encryptData, item);
                }
              }}
            />
          );
        }

        document.getElementById("cancel-button").style.backgroundColor = "red";

        // document.getElementById("scan-button").addEventListener("click", () => {
        //     handleScan(encryptedData, item);
        // });

        document
          .getElementById("cancel-button")
          .addEventListener("click", () => {
            Swal.close();
          });
      },
    });
  };

  useEffect(() => {
    fetchFormData();
  }, []);
  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <div className="relative">
        <div className="flex justify-between items-center  px-4 mt-6">
          <p className="font-semibold text-lg text-white">
            Registration Details
          </p>
          <div>
            <Tooltip title="Go Back" arrow>
              <button
                className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => navigate(-1)}
              >
                {"<"}
              </button>
            </Tooltip>
            <Tooltip title="Delete" arrow>
              <button
                whileHover={{ scale: 1.2, color: "#DC2626" }}
                whileTap={{ scale: 0.9 }}
                type="button"
                disabled={formData.id === ""}
                className="text-red-500 hover:text-red-700 focus:outline-none mx-4"
                onClick={() => handleDeleteFacilityRegistration(formData.id)}
              >
                <FontAwesomeIcon icon={faTrash} className="text-xl" />
              </button>
            </Tooltip>

            {/* <Tooltip title="Edit" arrow>
                    <button
                      whileHover={{ scale: 1.2, color: "#FACC15" }}
                      whileTap={{ scale: 0.9 }}
                      type="button"
                      disabled={formData.data===null}
                      onClick={()=> navigate(`/student/facility-reservation`, {state:{type:"edit", fid:fid, formValues:{id:formData.id,data:originalData}, fname}})}
                      className="text-white focus:outline-none mx-3 hover:text-yellow-500">
                      <FontAwesomeIcon icon={faPenToSquare} className="text-xl" />
                    </button>
                  </Tooltip> */}
          </div>
        </div>
        <div className="mt-6 px-6 relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
          <div className="min-h-screen-75 w-full overflow-x-auto pt-6">
            {formData.data ? (
              Object.entries(formData.data).map(([key, value]) => {
                let displayValue;
                let keyValue;
                switch (key) {
                  case "start_date_time":
                    keyValue = (
                      <span className="font-bold text-white w-40 capitalize">
                        Start Date & Time:{" "}
                      </span>
                    );
                    displayValue = (
                      <span className="text-white">
                        {value.split("T")[0]} &{" "}
                        {value.split("T")[1].split(".")[0]}
                      </span>
                    );
                    break;
                  case "end_date_time":
                    keyValue = (
                      <span className="font-bold text-white w-40 capitalize">
                        End Date & Time:{" "}
                      </span>
                    );
                    displayValue = (
                      <span className="text-white">
                        {value.split("T")[0]} &{" "}
                        {value.split("T")[1].split(".")[0]}
                      </span>
                    );
                    break;
                  default:
                    keyValue = (
                      <span className="font-bold text-white w-40 capitalize">
                        {key}:{" "}
                      </span>
                    );
                    displayValue = (
                      <span className="text-white">{String(value)}</span>
                    );
                }

                return (
                  <div
                    key={key}
                    className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4"
                  >
                    <p>
                      {keyValue}
                      {displayValue}
                    </p>
                  </div>
                );
              })
            ) : (
              <div className="w-full flex justify-center">
                <div className="bg-red-500 w-8/12 text-white text-center py-2 px-4 rounded-lg font-bold shadow-md">
                  Did not register for this facility yet.
                </div>
              </div>
            )}
            {formData.data ? (
              <>
                <div
                  key={"FacilityName"}
                  className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4"
                >
                  <p>
                    <span className="font-bold text-white w-40 capitalize">
                      Facility Name :{" "}
                    </span>
                    <span className="text-white">{String(fname)}</span>
                  </p>
                </div>
                <div
                  key={"ClubName"}
                  className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4"
                >
                  <p>
                    <span className="font-bold text-white w-40 capitalize">
                      Club Name:{" "}
                    </span>
                    <span className="text-white">{String(clubName)}</span>
                  </p>
                </div>
                <div
                  key={"AlternateMembers"}
                  className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4"
                >
                  <p>
                    <span className="font-bold text-white w-40 capitalize">
                      Alternate Contact Details:{" "}
                    </span>
                    <span className="text-white">
                      {String(alternateMembers)}
                    </span>
                  </p>
                </div>
                <div
                  key={"QR"}
                  className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4"
                >
                  <p>
                    <span className="font-bold text-white w-40 capitalize">
                      QR:{" "}
                    </span>
                    <span className="text-white">
                      <Tooltip title="Scan Qr" arrow>
                        <button
                          whileHover={{ scale: 1.2, color: "blue" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() =>
                            handleShowQR(
                              originalData.facility_registration_id,
                              originalData
                            )
                          }
                          className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        >
                          {/* <FontAwesomeIcon icon={faQrcode} className="text-xl" /> */}
                          View QR Code
                        </button>
                      </Tooltip>
                    </span>
                  </p>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewFacilityRegistration;
